import { setApiToken } from '@/api/client';
import accountApi from '@/api/modules/account';
import router from '@/routes';
import store from '@/store';
import { GTM_EVENTS } from '@/constants';
import { cookieGetters, cookieManager } from '@/helpers/cookieManager';
import i18n from '@/i18n';
import { skipNotifyingAboutNoSubscription } from '~/views/auth/billing-utils';

const redirectIfExpired = (isExpired, redirect, toastr) => {
  if (isExpired && redirect) {
    router.push({ name: 'AccountDetails' });
    if (toastr && !skipNotifyingAboutNoSubscription.value) {
      toastr.w(i18n.t('billing-subscription-error'));
    }

    return true;
  }

  return false;
};

const redirectIfRestricted = (isRestricted) => {
  if (isRestricted) {
    router.push({ name: 'settingsAccount' });

    return true;
  }

  return false;
};

const saveLoginData = function (data) {
  if (data.data.attributes.verified) {
    //Set pagination type for metrics for users
    store.dispatch('setIsAuthUser', true);
    store.dispatch('setIsNotStripeUser', data.data.attributes.is_not_stripe_user);
    store.dispatch('setPaymentDetailsLoaded', true);
    store.dispatch('saveUser', data);
    store.dispatch('saveSettings', data);
    setApiToken(cookieGetters.getApiKey());
    store.dispatch('fetchCurrencies');
    const isFreePriceType = data.data.attributes?.subscription?.price_type === 'free';

    const redirect = !isFreePriceType;

    // TODO ouch, forgot to pass toastr :((((
    // if only there was something that ensures that
    if (!redirectIfExpired(store.getters.getIsExpired, redirect)) {
      /**
       * GTM custom event successfully_logged_in
       */
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: GTM_EVENTS.SUCCESSFULLY_LOGGED_IN,
        uid: data.data.attributes.user_id,
      });
      router.push({ name: 'Overview' });
    }
  } else {
    router.push({ name: 'thankYou', query: { email: data.data.id } });
  }
};

const logout = function () {
  accountApi.logout();

  cookieManager.remove('api_key', null, process.env.NODE_ENV === 'production' ? 'keyword.com' : 'serpbook.me');
  cookieManager.remove('api_key');
  cookieManager.remove('onboarding');
  cookieManager.remove('showall');
  cookieManager.remove('userProfile');
  store.dispatch('setTutorialMode');
  setApiToken(null);

  router.push({ name: 'login' });

  if (window.Intercom) {
    window.Intercom('shutdown');
  }

  const posthog = Vue.prototype.$posthog;

  if (posthog) {
    posthog.reset();
  }
};

const version = {
  packageVersion: process.env.VERSION,
};

const checkRestrictedUser = () => {
  const restricted = cookieGetters.getIsRestricted();
  if (restricted) {
    try {
      return JSON.parse(restricted);
    } catch (error) {
      return false;
    }
  }
  return false;
};

export { version, logout, saveLoginData, redirectIfExpired, redirectIfRestricted, checkRestrictedUser };
